module.exports = __webpack_public_path__ + "assets/CCB.36475f82.svg";